import React, { useState, useEffect } from 'react';

interface AvailableSpacesBlockProps {
  availableSpaces: number;
  textFr: string;
  textEn: string;
  numberColor?: string;
  textFrColor?: string;
  textEnColor?: string;
}

function AvailableSpacesBlock({
  availableSpaces,
  textFr,
  textEn,
  numberColor = '#0054FF',
  textFrColor = '#0054FF',
  textEnColor = '#009FDF',
}: AvailableSpacesBlockProps) {
  const [displayValue, setDisplayValue] = useState(availableSpaces);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (availableSpaces !== displayValue) {
      setIsAnimating(true);

      // Animation progressive du nombre
      const difference = availableSpaces - displayValue;
      const steps = Math.abs(difference);
      const increment = difference > 0 ? 1 : -1;
      let currentStep = 0;

      const interval = setInterval(() => {
        currentStep++;
        setDisplayValue((prev) => {
          if (currentStep >= steps) {
            clearInterval(interval);
            setIsAnimating(false);
            return availableSpaces;
          }
          return prev + increment;
        });
      }, 80);

      return () => clearInterval(interval);
    }
  }, [availableSpaces, displayValue]);

  return (
    <div className="my-[1vh] flex flex-col items-center justify-center">
      <p
        className={`text-[28vw] font-extrabold leading-none transition-all duration-300 ${
          isAnimating ? 'scale-110' : 'scale-100'
        }`}
        style={{ color: numberColor }}
      >
        {displayValue}
      </p>
      <p
        className="text-[5vw] font-extrabold uppercase leading-none"
        style={{ color: textFrColor }}
      >
        {textFr}
      </p>
      <p
        className="text-[4vw] font-extrabold uppercase leading-none"
        style={{ color: textEnColor }}
      >
        {textEn}
      </p>
    </div>
  );
}

export default AvailableSpacesBlock;
